module.exports = __webpack_public_path__ + "static/19-7ada5e63bc0998b01c9351ccebc1d479.png";